import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class CustomCrudToastrService {

  constructor(private toastr: ToastrService) { }

  success(message: string, title?: string, overrideMessage?: string, overrideTitle?: string, options?: any) {
    this.toastr.success(message, title, options);
  }

  error(message: string, title?: string, overrideMessage?: string, overrideTitle?: string, options?: any) {
    this.toastr.error(message, title, options);
  }

  info(message: string, title?: string, overrideMessage?: string, overrideTitle?: string, options?: any) {
    this.toastr.info(message, title, options);
  }
}